<template><SimpleModuleDashboard :module-id="Modules.REPORTES" :profile-id="Profiles.PERSONAL" include-php-custom :actions="actions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default { components: { SimpleModuleDashboard }, data: () => ({ Modules, Profiles, actions: [
  { id: 'design', reference: 'design', route: 'ReportsStaffDesign', tone: 'primary' },
  { id: 'log', reference: 'log', route: 'ReportsStaffReportLog', tone: 'primary', group: 'Configuraciones' },
  { id: 'configuration', reference: 'configuration', route: 'ReportsStaffConfiguration', tone: 'primary', group: 'Configuraciones' },
] }) }
</script>
